import React, { useEffect, useState } from "react";
import { EyeOff, Eye } from "lucide-react";
import apiCall from "../network/api";
import { loader } from "../utils/svg";

export const ObcProfile = ({ email }) => {
  const [loading, setLoading] = useState(true);
  const [profileData, setProfileData] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await apiCall({
          endpoint: "/otp/get-signup-row",
          method: "GET",
          params: {
            email: email,
          },
        });
        setProfileData(result.data);
        setLoading(false);
      } catch (err) {
        console.log(err);
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [showPassport, setShowPassport] = useState(false);

  return (
    <div className="max-w-md mx-auto bg-white p-6 rounded-lg shadow-sm">
      {loading ? (
        <div className="max-w-lg mx-auto w-full flex justify-center items-center">
          {loader()}
        </div>
      ) : (
        <>
          <h2 className="font-bold text-gray-500 mb-6">Profile Details</h2>

          <form className="space-y-4">
            <div>
              <label
                htmlFor="fullName"
                className="block text-sm font-medium text-gray-500 mb-1"
              >
                Full Name
              </label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                defaultValue={`${profileData?.firstname} ${profileData?.lastname}`}
                className="w-full px-3 py-2 bg-gray-100 rounded-md text-sm text-gray-500 font-medium"
                disabled
              />
            </div>

            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-500 mb-1"
              >
                Email address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                defaultValue={profileData?.email}
                className="w-full px-3 py-2 bg-gray-100 rounded-md text-sm text-gray-500 font-medium"
                disabled
              />
            </div>

            <div>
              <label
                htmlFor="passport"
                className="block text-sm font-medium text-gray-500 mb-1"
              >
                Passport number
              </label>
              <div className="relative">
                <input
                  type={showPassport ? "text" : "password"}
                  id="passport"
                  name="passport"
                  defaultValue={profileData?.passportNo}
                  className="w-full px-3 py-2 bg-gray-100 rounded-md  pr-10 text-sm text-gray-500 font-medium"
                  disabled
                />
                <button
                  type="button"
                  onClick={() => setShowPassport(!showPassport)}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                >
                  {showPassport ? (
                    <EyeOff className="h-5 w-5 text-gray-400" />
                  ) : (
                    <Eye className="h-5 w-5 text-gray-400" />
                  )}
                </button>
              </div>
            </div>

            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-500 mb-1"
              >
                Phone Number
              </label>
              <input
                type="phoneNumber"
                id="phoneNumber"
                name="phoneNumber"
                defaultValue={profileData?.phoneNumber}
                className="w-full px-3 py-2 bg-gray-100 rounded-md text-sm text-gray-500 font-medium"
                disabled
              />
            </div>
          </form>
        </>
      )}
    </div>
  );
};
